import React from "react";
import BilateralLoanDataView from "./BilateralLoanDataView";
import {
    amount,
    rate,
    numberWithComma,
    price,
    decimalFormat,
    replaceStringIfZero,
    formattedPremium
} from "../../utils/formatters/Numbers"
import PropTypes from "prop-types";

export default class BilateralLoanDataContainer extends React.Component {
    constructor(props) {
        super(props);
        this.getDetailLoanFirstColumn = this.getDetailLoanFirstColumn.bind(this);
        this.getDetailLoanSecondColumn = this.getDetailLoanSecondColumn.bind(this);
        this.getDetailLoanThirdColumn = this.getDetailLoanThirdColumn.bind(this);
        this.getDetailLoanFourthColumn = this.getDetailLoanFourthColumn.bind(this);
        this.getLoan = this.getLoan.bind(this);

        this.state = {
            selectedLoan: props.selectedLoan,
            detailLoan_1: [],
            detailLoan_2: [],
            detailLoan_3: [],
            detailLoan_4: [],
        };
    }

    getLoan() {
        this.getDetailLoanFirstColumn();
        this.getDetailLoanSecondColumn();
        this.getDetailLoanThirdColumn();
        this.getDetailLoanFourthColumn();
    }

    getDetailLoanFirstColumn() {
        let loan = this.state.selectedLoan;
        let loanData = [
            {name: "Folio", value: loan.id},
            {name: "Emisora", value: loan.instrument},
            {name: "Títulos", value: numberWithComma(loan.title)},
            {name: "Precio", value: price(loan.price)},
            {name: "Importe", value: amount(loan.amount)},
        ];
        this.setState({
            detailLoan_1: loanData,
        });
    }

    getDetailLoanSecondColumn() {
        let loan = this.state.selectedLoan;
        let loanData = [
            {name: "Plazo", value: replaceStringIfZero(loan.term)},
            {name: "Tasa", value: rate(loan.rate)},
            {name: "Premio", value: formattedPremium(loan.premium)},
            {name: "Tipo de Préstamo", value: 'Bilateral'},
            {name: "Estatus", value: loan.status},
        ];

        this.setState({
            detailLoan_2: loanData,
        });
    }

    getDetailLoanThirdColumn() {
        let loan = this.state.selectedLoan
        let loanData = [
            {name: "Prestamista", value: loan.lender},
            {name: "Cta. Prestamista", value: loan.lenderAccount},
            {name: "Prestatario", value: loan.borrower},
            {name: "Cta. Prestatario", value: loan.borrowerAccount},
            {name: "Fecha Valor", value: loan.valueDate}
        ];
        this.setState({
            detailLoan_3: loanData,
        });
    }
    getDetailLoanFourthColumn() {
        let loan = this.state.selectedLoan
        let loanData = [
            {name: "% Requerido", value: decimalFormat(loan.requiredPercentage, "left", 4)},
            {name: "% Garantizado", value: decimalFormat(loan.collateralPercentage, "left", 4)},
        ];
        this.setState({
            detailLoan_4: loanData,
        });
    }

    render() {
        return <BilateralLoanDataView
            detailLoan_1={this.state.detailLoan_1}
            detailLoan_2={this.state.detailLoan_2}
            detailLoan_3={this.state.detailLoan_3}
            detailLoan_4={this.state.detailLoan_4}
        />
    }
};

BilateralLoanDataContainer.propTypes = {
    selectedLoan: PropTypes.object.isRequired,
};